module.exports = __webpack_public_path__ + "img/screen.94a87d01.png";